import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import BannerDetail from "../pages/BannerDetail";
import { subItemHooks } from "../hooks";

function normalizeOne(payload) {
  if (Array.isArray(payload)) return payload[0] ?? null;
  if (payload && Array.isArray(payload.data)) return payload.data[0] ?? null;
  if (payload && typeof payload.data === "object") return payload.data;
  if (payload && typeof payload === "object") return payload;
  return null;
}

const BannerLayout = () => {
  const [banner, setBanner] = useState(null); 
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const fetchImage = async () => {
    setLoading(true);
    try {
      const response = await subItemHooks.imageList();
      const one = normalizeOne(response?.data);
      setBanner(one);
    } catch (error) {
      console.error("카드뉴스 데이터를 가져오는 중 오류가 발생했습니다.", error);
      message.error("카드뉴스 데이터를 불러오지 못했습니다.");
      setBanner(null);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (updateData) => {
    try {
      const res = await subItemHooks.bannerUpdate({
        banner: updateData.image_img,
        bannerId: updateData.id,
        bannerLocation: updateData.banner_location,
        bannerUrl: updateData.banner_link,
        bannerPosition: updateData.banner_position,
      });
      if (res.IsError) throw new Error("update banner error");
      message.success("카드뉴스가 수정되었습니다.");
      setIsModalVisible(false);
      fetchImage();
    } catch (error) {
      message.error("카드뉴스 수정에 실패했습니다.");
    }
  };

  useEffect(() => {
    fetchImage();
  }, []);

  return (
    <div>
      {loading ? (
        <div>로딩 중...</div>
      ) : banner ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
      <img
        src={banner.image_img}
        alt={banner.title ?? "카드뉴스"}
        style={{ width: 320, height: 160, objectFit: "cover", borderRadius: 8 }}
      />
      <Button
        type="primary"
        onClick={() => setIsModalVisible(true)}
        style={{ alignSelf: "center" }} // 안전하게 중앙 유지
      >
        수정하기
      </Button>
    </div>
  </div>
) : (
  <div>표시할 카드뉴스가 없습니다.</div>
      )}

      {/* 수정 모달 */}
      <BannerDetail
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        banner={banner}
        onUpdate={handleUpdate}
      />
    </div>
  );
};

export default BannerLayout;
